export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"defaults":{"httpEndpoint":"https://api1.emissary.ai/graphql","httpLinkOptions":{"credentials":"include"},"defaultOptions":{"watchQuery":{"fetchPolicy":"cache-and-network"}},"tokenName":"auth-token","tokenStorage":"localStorage","authType":null,"websocketsOnly":false,"authHeader":"Authorization"}}
}